<template>
    <div class="trailer container-div">
        <h1 class="small-h1">Watch the Creature Fear Official Trailer</h1>
        <div class="video-container">
            <div style="padding:52.73% 0 0 0;position:relative;"><iframe src="https://player.vimeo.com/video/1125046931?h=743b07d036&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameborder="0" allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share" referrerpolicy="strict-origin-when-cross-origin" style="position:absolute;top:0;left:0;width:100%;height:100%;" title="Creature Fear - Festival Trailer"></iframe></div>
        </div>
    </div>
</template>

<script>
</script>